import { useSelector } from "react-redux";

// Component
import HomeContent from "components/templates/home";
import Main from "components/common/Layout/Main";

// Libs && configs
import Translation from "libs/Translation";
import { appConfig, apiConfig } from "configs";

const Home = ({ citiesList = [], specialtiesList = [] }) => {
  const { webConfig } = useSelector((state) => state.core);

  const title = Translation.t("title.home");
  const description = Translation.t("text.vclinic-get-appointment-online");

  const breadCrumb = {
    itemListElements: [
      {
        position: 1,
        name: Translation.t("title.home"),
        item: "https://vclinic.io",
      },
    ],
  };

  const seo = {
    title: title,
    description: description,
    h1Title: title,
    additionalMetaTags: [
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "@vclinic4" },
      { name: "twitter:title", content: Translation.t("title.twitter") },
      {
        name: "twitter:description",
        content: Translation.t("text.twitter-desc"),
      },
      { name: "twitter:creator", content: "@vclinic4" },
      {
        name: "twitter:image",
        content: `${appConfig.site_url}/nextasset/images/Logo.svg`,
      },
    ],
    openGraph: {
      title,
      description,
      site_name: Translation.t("title.default"),
      images: [
        {
          url: `${appConfig.site_url}/nextasset/images/Logo.svg`,
          type: "image/svg",
          alt: Translation.t("title.default"),
        },
      ],
    },
  };

  return (
    <Main breadCrumb={breadCrumb} seo={seo}>
      <HomeContent
        webConfig={webConfig}
        cities={citiesList}
        specialties={specialtiesList}
      />
    </Main>
  );
};

export default Home;

export const getServerSideProps = async ({ query }) => {
  let result;
  let data;
  let notFound = false;

  let lang = "fa";
  if (query.lang) {
    lang = query.lang;
  }

  try {
    result = await Promise.all([
      fetch(`${appConfig.nest_api_base_url}${apiConfig.getCities.endpoint}`),
      fetch(
        `${appConfig.nest_api_base_url}${apiConfig.getSpecialties.endpoint}?lang=${lang}&SpecialtyType=SPECIALTY`
      ),
    ]);

    if (result) {
      data = await Promise.all([result[0].json(), result[1].json()]);
    }
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      citiesList: data?.[0]?.data ?? [],
      specialtiesList: data?.[1]?.data ?? [],
    },
    notFound: notFound,
  };
};
